import { Outlet, useLocation } from "react-router-dom";
import SiteFooter from "./SiteFooter";
import SiteNav from "./SiteNav";
import ThemeToggle from "./ThemeToggle";
import GlobalSeo from "./seo/GlobalSeo";
import { getNavCurrent } from "../lib/navConfig";

export default function Layout() {
  const { pathname } = useLocation();
  const current = getNavCurrent(pathname);
  const isHome = pathname === "/";

  return (
    <div className="site-shell">
      <GlobalSeo />
      <SiteNav variant={isHome ? "overlay" : "solid"} current={current} />
      <main className="site-main">
        <Outlet />
      </main>
      <SiteFooter current={current} />
      <ThemeToggle />
    </div>
  );
}
